import styled from 'styled-components'
import { COLORS } from 'consts/colors'

interface ITtsWebFlyoutWrapperContainerProps {
  $togglerCenterPosition?: {
    top: number
    left: number
  }
  $width?: number
  $height?: number
}

export const TtsWebFlyoutWrapperContainer = styled.div<ITtsWebFlyoutWrapperContainerProps>`
  position: relative;
  width: ${({ $width }) => ($width ? `${$width}px` : '400px')};
  height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
  max-width: 100%;
  padding: 16px;
  border-radius: 4px;
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.borderColor};
  box-shadow: 0px 4px 10px 0px rgba(27, 85, 216, 0.28);

  transition: height 0.3s ease-in-out;
  &::after {
    top: ${({ $togglerCenterPosition }) =>
      $togglerCenterPosition ? `${$togglerCenterPosition.top}px` : '0'};
    left: ${({ $togglerCenterPosition }) =>
      $togglerCenterPosition ? `${$togglerCenterPosition.left}px` : '0'};
    content: '';
    position: fixed;
    width: 10px;
    height: 10px;
    background: ${COLORS.white};
    border-top: 1px solid ${COLORS.borderColor};
    border-left: 1px solid ${COLORS.borderColor};

    transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  }
`
